export enum WhiteLabelHostName {
  STREAM_SHOP = 'streamshop',
}
